import '@/app/styles/globals.css';

import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { AppProviders } from '@/app/providers';
import { env } from '@/shared/lib/env';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

// Runtime accessibility audit (development only).
// Enable with VITE_A11Y_AUDIT=true so the default dev experience stays quiet.
// Violations are logged to the browser console as you navigate.
if (import.meta.env.DEV && env.VITE_A11Y_AUDIT) {
  void import('@axe-core/react').then(({ default: axe }) => {
    void axe(React, ReactDOM, 1000);
  });
}

// Core Web Vitals reporting (opt-in). Logs LCP / CLS / INP / FCP / TTFB to
// the browser console with rating. Enable with VITE_PERF_REPORT=true.
if (env.VITE_PERF_REPORT) {
  void import('@/shared/lib/reportWebVitals').then(({ reportWebVitals }) => {
    reportWebVitals();
  });
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
